import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [rate, setRate] = useState(null);

  const loadRate = useCallback(async (refresh = false) => {
    try {
      const { data } = await api.get("/rate", { params: { refresh } });
      setRate(data);
    } catch {
      /* rate optional */
    }
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("jly_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (user) loadRate();
  }, [user, loadRate]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("jly_token", data.token);
    const me = await api.get("/auth/me").then((r) => r.data).catch(() => data.user);
    setUser(me);
  };

  const logout = () => {
    localStorage.removeItem("jly_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, rate, loadRate, isAdmin: user && user.role === "admin" }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
